import { ViewMetadata } from "@data/cer-data-types";
import { CerFormView, ICerViewComponent } from "@form/cer-form-view";

import { DisplayMode, ItemAlign } from "@syncfusion/ej2-angular-navigations";

// Action types
export enum UiActionTypeEnum {
  Created = 'created',
  Destroyed = 'destroyed',
  Init = 'init',
  Loaded = 'loaded',
  DataBound = 'dataBound',
  DataSourceChanged = 'dataSourceChanged',
  DataLoad = 'dataLoad',
  DataFKLoad = 'dataFKLoad',
  DataStateChange = 'dataStateChange',
  VirtualScroll = 'virtualscroll',
  Research = 'research',
  Refresh = 'refresh',
  RefreshPersistence = 'refreshPersistence',
  RefreshFromParent = 'refreshFromParent',
  Redraw = 'redraw',
  Reflow = 'reflow',
  TitleUpdate = 'titleUpdate',
  BeginEdit = 'beginEdit',
  Add = 'add',
  Save = 'save',
  BatchDelete = 'batchDelete',
  BatchAdd = 'batchAdd',
  //BatchEdit = 'batchEdit',
  BatchSave = 'batchSave',
  BatchCancel = 'batchCancel',
  Delete = 'delete',
  Cancel = 'cancel',
  Sorting = 'sorting',
  CellSelecting = 'cellSelecting',
  CellSelect = 'cellSelect',
  CellDeselect = 'cellDeselect',
  RowSelecting = 'rowSelecting',
  RowSelect = 'rowSelect',
  RowDeselect = 'rowDeselect',
  RowClick = 'rowClick',
  RowDoubleClick = 'rowDoubleClick',
  FilterSearchBegin = 'filtersearchbegin',
  FilterBeforeOpen = 'filterbeforeopen',
  FilterChoiceRequest = 'filterchoicerequest',
  FilterAfterOpen = 'filterafteropen',
  Filtering = 'filtering',
  Paging = 'paging',
  Searching = 'searching',
  ColumnState = 'columnstate',
  BeforeOpenColumnChooser = 'beforeOpenColumnChooser',
  BeforeCloseColumnChooser = 'beforeCloseColumnChooser',
  BeforeOpenAdaptiveDialog = 'beforeOpenAdaptiveDialog',
  ExcelExport = 'excelExport',
  ExcelExportHeaderCell = 'excelExportHeaderCell',
  ExcelExportCell = 'excelExportCell',
  ExcelExportFinalPageSetup = 'excelExportFinalPageSetup',
  ViewPort = 'viewPort',
  PanesShow = 'panesShow',
  Splitter = 'splitter',
  ContainerResize = 'containerResisze',
  ActionFailure = 'failure',
  Grouping = 'grouping',
  Ungrouping = 'ungrouping',
  Reorder = 'reorder',
  KeyboardShortcut = 'keyboardShortcut',
  ContextMenuOpen = 'contextMenuOpen',
  ContextMenuItem = 'contextMenuItem',
  ToolbarMenuItem = 'toolbarMenuItem',
  QueryCellInfo = 'queryCellInfo',
  ChatClicked = 'chatClicked',
  CommandClicked = 'commandClicked',
  LinkClicked = 'linkClicked',
  PersistenceApply = 'persistenceApply'
}

export type CerEventSubAction = 'none' | 'edit' | 'add';

// Command sources
export enum UiCommandSourceEnum {
  Toolbar = "toolbar",
  ContextMenu = "contextMenu",
  KeyboardShortcut = "keyboardShortcut",
  Command = "gridCommand",
  ActionBegin = "actionBegin",
  ActionComplete = "actionComplete",
  ActionFailure = "actionFailure",
  DesignChange = "designChange",
  TabPaneChange = "tabPaneChange",
  Event = "event"
};

export type CerToolbarOverflowType = 'show' | 'hide' | 'auto' | 'allways';

export type CerToolbarItemAlign = 'left' | 'center' | 'right';
export type CerToolbarItemAlignPositionType = 'next' | 'last' | 'first';
export function cerToolbarItemAlignConvert(align:  CerToolbarItemAlign): ItemAlign {
  return (align?.length > 0 ? (align.charAt(0).toUpperCase() + align.slice(1)) : 'Left') as ItemAlign;
}

export type UiCommand = {
  id: string;
  text: string;
  tooltipText?: string;
  cssClass?: string;
  iconCss?: string;
  target?: string;
  align?: CerToolbarItemAlign;
  separator?: 'header' | 'content';
  href?: string;
  toolbarShowTextOn?: DisplayMode;
  toolbarPosition?: CerToolbarItemAlignPositionType;
  toolbarOverflow?: CerToolbarOverflowType;
  toolbarTemplate?: string | Object | Function;
  disabled?: boolean;
  visible?: boolean;
  needSelection?: boolean;
  htmlAttributes?: { [key: string]: string; };
  data?: any;
}

// Keyboard
export type UiKeyboardShortcut = {
  code: string;
  ctrl: boolean;
  alt: boolean;
  shift: boolean;
  cmd: UiCommand;
  allowsPreventDefault?: boolean;
  enabled?: boolean;
  global?: boolean;
  informationOnly?: boolean;
}

// Emit events
export type UiCommandEvent = {
  source: UiCommandSourceEnum;
  appComponent?: ICerViewComponent;
  formView?: CerFormView;
  viewMetadata?: ViewMetadata;
  commandId: string;
  args: any;
  rowsData?: any[];
  rowData?: any;
  rowDataOriginal?: any;
  actionType: UiActionTypeEnum;
  subAction: CerEventSubAction;
  columnName?: string;
  command?: UiCommand;
  cancel?: boolean;
  dataBindDeferred?: boolean;
};

